/**
 * Created by mathias.gamperl on 17.02.2016.
 */
export default function () {
  return function(scope, element, attrs) {
    if (scope.$last) setTimeout(function(){
      scope.$emit('LastElement_'+attrs.lastRepeat, element, attrs);
    }, 1);
  };
};


// WEBPACK FOOTER //
// ./src/ui/app/directives/last-repeat.js